import { setActivePinia, createPinia } from 'pinia';

export const setupPinia = () => {
  const pinia = setActivePinia(createPinia());

  return pinia;
};

export default null;
